import { useAppSelector } from "../store/hook/store.hook";

export const useRoleCheck = (requiredRoles: string[]) => {
    const { rol } = useAppSelector((state) => state.profile);
    return requiredRoles.includes(rol);
};